import { Component } from '@angular/core';
import { ScreenService } from '@core/framework/screen.service';

@Component({
    selector: 'm4u-empty-layout',
    templateUrl: './emptylayout.component.html',
    styleUrls: ['./emptylayout.component.scss']
})
export class EmptyLayoutComponent {
    constructor(public screen: ScreenService) {

    }
}